import { render, staticRenderFns } from "./taos2.vue?vue&type=template&id=3c926a60&scoped=true&"
import script from "./taos2.vue?vue&type=script&lang=js&"
export * from "./taos2.vue?vue&type=script&lang=js&"
import style0 from "./taos2.vue?vue&type=style&index=0&id=3c926a60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c926a60",
  null
  
)

export default component.exports